import { faBell, faCheckDouble } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { NotificationStatus } from 'api/notifications';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { RoutePaths } from 'constant';

interface NotificationsEmptyStateProps {
  status: NotificationStatus;
}

export const NotificationsEmptyState: FC<NotificationsEmptyStateProps> = ({
  status,
}) => {
  return status === NotificationStatus.New ? (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faBell} />}
        title={<FormattedMessage id="notifications.new.empty.title" />}
        message={<FormattedMessage id="notifications.new.empty.message" />}
        secondaryCTA={
          <Link
            to={RoutePaths.notificationsSettings}
            data-preview-disable="true"
          >
            <EmptyState.CallToAction.Secondary>
              <FormattedMessage id="notifications.new.empty.secondary" />
            </EmptyState.CallToAction.Secondary>
          </Link>
        }
      />
    </EmptyStateContainer>
  ) : status === NotificationStatus.Cleared ? (
    <EmptyStateContainer>
      <EmptyState
        image={<EmptyStateIcon icon={faCheckDouble} />}
        title={<FormattedMessage id="notifications.cleared.empty.title" />}
        message={<FormattedMessage id="notifications.cleared.empty.message" />}
        /* secondaryCTA={
          <Link to={RoutePaths.notifications}>
            <EmptyState.CallToAction.Secondary
              href="https://www.rocketlane.com/"
              target="_blank"
            >
              <FormattedMessage id="notifications.cleared.empty.secondary" />
            </EmptyState.CallToAction.Secondary>
          </Link>
        } */
      />
    </EmptyStateContainer>
  ) : null;
};
